import { partnerServices } from "../../config/axios";

export const UPDATE_IP_WHITELIST_REQUEST = 'UPDATE_IP_WHITELIST_REQUEST';
export const UPDATE_IP_WHITELIST_SUCCESS = 'UPDATE_IP_WHITELIST_SUCCESS';
export const UPDATE_IP_WHITELIST_FAILURE = 'UPDATE_IP_WHITELIST_FAILURE';




export const updateIPwhitelistAction = (requestData, authToken) => async (dispatch) => {
    dispatch({ type: UPDATE_IP_WHITELIST_REQUEST });
    await partnerServices
        .post("updateIsIpWhitelist", requestData, {
            headers: { AuthToken: authToken }
        })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch({ type: UPDATE_IP_WHITELIST_SUCCESS, payload: res.data });
                    break;
                default:
                    dispatch({ type: UPDATE_IP_WHITELIST_FAILURE, payload: res.data });
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: UPDATE_IP_WHITELIST_FAILURE, payload: err.message });
        });
};